import PropTypes from "prop-types";

import styled from "styled-components/macro";

import FnrTypography from "FnrTypography";
import ActivateFNPButton from "Giving/Marketing/ActivateFNPButton";

import FnrIcon from "UI/FnrIcon";
import { colors } from "UI/colors";

export default function ReportsSplashContent({ showUpgradeButton = true }) {
  return (
    <Products>
      <Product>
        <div>
          <TitleIcon>
            <FnrIcon fad fa-code-branch />
          </TitleIcon>
          <FnrTypography type="header" fontSize="decorative2">
            Smart Groups
          </FnrTypography>
          <Description>
            <FnrTypography type="copy" fontSize="lg">
              Smart Groups is exclusive to the{" "}
              <Strong>Flocknote Complete</Strong> plan, which unlocks a robust,
              integrated database that supercharges your member management and
              engagement. Add{" "}
              <Strong>
                $75&nbsp;/&nbsp;month. No&nbsp;contracts. Cancel&nbsp;anytime.
              </Strong>
            </FnrTypography>
          </Description>
        </div>
        <Ul>
          {smartGroupMarketingPoints.map(({ icon, label }) => (
            <Li key={label}>
              <Span>
                <i className={`fas ${icon}`} />
              </Span>
              <FnrTypography type="copy" fontSize="md">
                {label}
              </FnrTypography>
            </Li>
          ))}
        </Ul>
        <div>
          {showUpgradeButton && <ActivateFNP />}
          <A href="https://flocknote.com/people" target="_blank">
            Learn&nbsp;More
          </A>
        </div>
      </Product>
    </Products>
  );
}

ReportsSplashContent.propTypes = {
  showUpgradeButton: PropTypes.bool,
};

const smartGroupMarketingPoints = [
  {
    icon: "fas fa-user-circle",
    label: "Unlimited custom profile fields & personalized data storage",
  },
  {
    icon: "fas fa-table",
    label: "Attendance & participation tracking",
  },
  {
    icon: "fas fa-dollar-sign",
    label: "Advanced giving tracking, campaigns, pledges, EOY tax receipts",
  },
  {
    icon: "fas fa-file-edit",
    label: "Family & visitor registration",
  },
  {
    icon: "fas fa-home",
    label: "Household grouping & proxy contacts",
  },
];

const TitleIcon = styled.div`
  color: #278dc1;
  font-size: 52px;
`;

const Products = styled.div`
  font-weight: normal;
  display: flex;
  flex-wrap: wrap;
`;

const Product = styled.div`
  max-width: 440px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto 1rem;
  padding: 0 2rem;
`;

const Strong = styled.strong`
  font-weight: bold;
  font-style: italic;
`;

const Description = styled.p`
  color: #2a557a;
`;

const Ul = styled.ul`
  /* reset */
  list-style-type: none;
  margin-block-start: 10px;
  margin-block-end: 0;
  padding-inline-start: 0;
`;

const Li = styled.li`
  display: flex;
  align-items: center;
  margin: 2rem 0;

  &:first-child {
    margin: 0 0 2rem;
  }
`;

const Span = styled.span`
  text-align: center;
  margin-right: 1rem;
  width: 30px;
`;

const ActivateFNP = styled(ActivateFNPButton)`
  margin: 1rem 1rem 1rem 0;
`;

const A = styled.a`
  display: inline-block;
  color: ${colors.fnGray500};
  text-decoration: none;
  margin-left: 1rem;
`;